module.exports = __webpack_public_path__ + "media/57_Long.9b89fa5d.mp3";